import { ChildrenItem } from "../../base"
import { loginLayout } from "./model"
import { loginHome, bs } from "./diffrence_options"

let loginIcon = "icon-portal-menu_login"
import bigScreenIcon from "assets/images/leftMenu/login/icon_login.png"
let cover = [
  require("assets/images/leftMenu/login/login-style1.png"),
  require("assets/images/leftMenu/login/login-style2.png")
]
export let login_children = []
export let bigScreen_login_children = []
for (let i = 0; i < loginHome.length; i++) {
  login_children.push(
    new ChildrenItem("样式" + (i + 1), loginIcon, "emptyLayoutComponent", new loginLayout(loginHome[i]),cover[i])
  )
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_login_children.push(
    new ChildrenItem("样式" + i, bigScreenIcon, "emptyLayoutComponent", new loginLayout(bs[i]))
  )
}